import React from "react"
import styled from "styled-components"
import { Container, Line, Content, Person } from "./Quote.styles"

export const Quote = ({ data }) => {
	const title = data.primary.quote_name[0]?.text
	const content = data.primary.content[0]?.text
	const background = data.primary.background_colour
	const background_image = data.primary.background_image?.url
	const text_colour = data.primary.text_colour
	const name_colour = data.primary.quote_name_colour
	const line_colour = data.primary.divider_colour

	return (
		<>
			{background_image ? (
				<Container style={{ backgroundImage: "url('" + background_image + "')" }}>
					<Line style={{ background: "" + line_colour + "" }}></Line>
					<Content style={{ color: "" + text_colour + "" }}>{content}</Content>
					<Person style={{ color: "" + name_colour + "" }}>{title}</Person>
					<Line style={{ background: "" + line_colour + "" }}></Line>
				</Container>
			) : (
				<Container style={{ background: "" + background + "" }}>
					<Line style={{ background: "" + line_colour + "" }}></Line>
					<Content style={{ color: "" + text_colour + "" }}>{content}</Content>
					<Person style={{ color: "" + name_colour + "" }}>{title}</Person>
					<Line style={{ background: "" + line_colour + "" }}></Line>
				</Container>
			)}
		</>
	)
}
